export class HubVisitorPromotionImage {
  public link: string;
  public image: string;
  public isTop: Boolean;
  public isDisabled: Boolean;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/models/hub/hub.visitor.promotion.image.ts